import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg2040 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32.45966,
	height: 26.29706,
	viewBox: "0 0 32.45966 26.29706",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "20-40" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.22833,0A16.18124,16.18124,0,0,0,9.68506,1.39288L10.722,3.55994a13.75223,13.75223,0,0,1,11.006.01422L22.7796,1.37555A16.19961,16.19961,0,0,0,16.22833,0Z",
			style: { fill: "#d9d9d9" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.11951,13.01544l-2.338.54437a13.90687,13.90687,0,0,1,.26014,2.67279,13.75559,13.75559,0,0,1-2.96851,8.56275l1.89722,1.49908.25476-.331a16.0444,16.0444,0,0,0,2.89441-12.94794Z",
			style: { fill: "#d9d9d9" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.152,24.49255A13.634,13.634,0,0,1,2.69489,13.56787l-2.3747-.55438-.00677.03119A16.2839,16.2839,0,0,0,3.48926,26.29706L5.3866,24.798Z",
			style: { fill: "#00AD11" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.67352,1.82477,22.63538,3.99512a13.81867,13.81867,0,0,1,6.89959,8.5957l2.3689-.55151A16.23587,16.23587,0,0,0,23.67352,1.82477Z",
			style: { fill: "#d9d9d9" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.77826,1.81525a16.23605,16.23605,0,0,0-8.211,10.22918l2.34247.54682A13.81878,13.81878,0,0,1,9.82788,4.00873Z",
			style: { fill: "#00AD11" }
		})
	]
});
export default Svg2040;
